import { BaseModel } from './base.model';
import { ActionPlanModel } from './action-plan.model';
import { UnconformityModel } from './unconformity.model';
import { QuestionUnconformityResponseModel } from './question-unconformity-response.model';

export class QuestionResponseModel extends BaseModel {
    response: string;
    unconformity: UnconformityModel;

    // unconformity_observation: string;

    action_plans: ActionPlanModel[];
    question_unconformity_responses: QuestionUnconformityResponseModel[];

    constructor(questionResponse?: QuestionResponseModel) {
        super();

        this.response = questionResponse ? questionResponse.response : null;

        this.action_plans = questionResponse ? questionResponse.action_plans : [];
        this.question_unconformity_responses = questionResponse ? questionResponse.question_unconformity_responses : [];

        // this.unconformity_observation = questionResponse ? questionResponse.unconformity_observation : null;

        this.unconformity = questionResponse ? questionResponse.unconformity : new UnconformityModel;
    }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/question_response.model.ts